<template>
	<div class="container">
		<div ref="oneHeight">
			<p class="conentTitle">App下载</p>
			<div class="mainFirst">
				<div class="main">
					<div><img src="../../../public/images/download/phone.png" alt="" /></div>
					<div>
						<ul>
							<li>
								<img src="../../../public/images/download/code1.jpg" alt="" />
								<p>服务组织端下载</p>
							</li>
							<li>
								<img src="../../../public/images/download/code2.jpg" alt="" />
								<p>服务人员端下载</p>
							</li>
							<li>
								<img src="../../../public/images/download/code3.jpg" alt="" />
								<p>服务对象端下载</p>
							</li>
						</ul>
						<p class="downLoad">App下载</p>
					</div>
				</div>
			</div>
		</div>

		<p class="conentTitle">关注我们</p>
		<div class="followUs">
			<img src="../../../public/images/download/ybkLogo.jpg" alt="" />
			<p>关注颐倍康微信公众号，获取最新养老资讯</p>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {};
	},

	mounted() {
		let ownOne = this.$refs.oneHeight.offsetHeight;
		let headAll = parseInt(window.sessionStorage.getItem('headHeight'));
		this.$bus.$on('getApp', val => {
			if (val == 2) {
				document.documentElement.scrollTop = ownOne + headAll;
			}
		});
	},

	methods: {
		
	},
	
};
</script>

<style scoped="scoped">
.container {
	/* height: 400px;
	background: url('../../../public/images/download/phoneBg.jpg') no-repeat;
	background-size: 100% 100%;
	background-position: 100% 100%; */
}
.container .mainFirst {
	height: 450px;
	background: url('../../../public/images/download/phoneBg.jpg') no-repeat;
	background-size: 100% 100%;
	background-position: 100% 100%;
}
.container .main {
	padding: 0 16%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
}
.main > div:first-of-type {
	width: 35%;
	height: 100%;
	box-sizing: border-box;
}
.main > div:first-of-type > img {
	width: 100%;
	height: 100%;
}
.main > div:nth-of-type(2) {
	width: 48%;
	height: 100%;
}
.main > div:nth-of-type(2) ul {
	width: 100%;
	height: 190px;
	margin-top: 100px;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
}
.main > div:nth-of-type(2) ul > li {
	width: 150px;
	height: 100%;
}
.main > div:nth-of-type(2) > ul > li > img {
	width: 150px;
	height: 150px;
}
.main > div:nth-of-type(2) > ul > li > p {
	font-size: 17px;
	text-align: center;
	color: #666666;
	margin-top: 14px;
}
.container .conentTitle {
	text-align: center;
	font-size: 34px;
	padding: 40px 0;
	color: #666666;
}
.downLoad {
	background: #358fc3;
	width: 150px;
	padding: 10px 0;
	text-align: center;
	font-size: 22px;
	color: #f7f6f4;
	border-radius: 8px;
	margin: 40px auto;
	cursor: pointer;
}
.followUs {
	/* height:350px; */
	padding: 50px 0;
	background: #fff;
	margin-bottom: 260px;
	text-align: center;
}
.followUs > img {
	width: 200px;
	height: 200px;
	margin-bottom: 20px;
}
.followUs > p {
	font-size: 22px;
	color: #666666;
	text-align: center;
}
</style>
